// import packages
import React from 'react'
import { toast } from 'react-toastify'
import { useParams, Redirect } from 'react-router-dom'

// import apis

// import redux, selectors, actions
import { useSelector, useDispatch } from 'react-redux'
import { loadCards } from 'redux/actions/cards'
import { switchCardFormat } from 'redux/actions/memory'

// import contexts
import { AuthContext } from 'contexts/AuthContext'

// import hooks

// import utilities
import { publicFetch } from 'helpers/fetch'

// import common elements
import { PageLayout } from 'components/elements/Layout'

// import components
import CardDisplay from './CardDisplay'

// import styles

// local constants

// --------------------

const Card = ({ edit, print }) => {

  const { id } = useParams()


  const reduxDispatch = useDispatch()
  const { getCurrentUserId } = React.useContext(AuthContext)
  const currentUserId = getCurrentUserId()

  const card = useSelector(state => state.cards[id])

  const cardFormat = useSelector(state => state.memory.cardFormat)
  const [processedInitialFormatRequest, setProcessedInitialFormatRequest] = React.useState(false)

  const [error, setError] = React.useState(false)
  const [title, setTitle] = React.useState(card ? card.title : 'Loading')

  React.useEffect(() => {
    if (!processedInitialFormatRequest && print && cardFormat !== 'print' ) {
      reduxDispatch(switchCardFormat())
      setProcessedInitialFormatRequest(true)
    }
  }, [print, cardFormat, processedInitialFormatRequest, setProcessedInitialFormatRequest, reduxDispatch])

  React.useEffect(() => {
    const abortController = new AbortController()
    if (!card) {
      publicFetch
        .get(`cards/${id}`)
        .then(response => {
          if (response.data.error) {
            toast.error(response.data.error)
            setError(true)
          } else {
            reduxDispatch(loadCards({ cards: [response.data.card] }))
          }
        })
        .catch(err => {
          toast.error(`Error: ${err.message}`, {
            autoClose: 10000,
          })
        })
    }
    return () => {
      abortController.abort()
    }
  }, [id, card, reduxDispatch])

  React.useEffect(() => {
    if (card && edit) {
      if (
        card.creator_id !== currentUserId &&
        !card.editors.includes(currentUserId)
      ) {
        setError('Sorry, you do not have permission to edit that card.')
      }
    }
  }, [card, edit, currentUserId])

  React.useEffect(() => {
    setTitle(card ? card.title : 'Loading')
  }, [card])

  if (error) {
    return <Redirect to='/' />
  }

  return (
    <PageLayout title={title}>
      {card ? <CardDisplay
            format={cardFormat}
            card={card}
            editing={edit}
            updateTitle={setTitle}
          />
        : <div>Card not loaded.</div>
      }
    </PageLayout>
  )
}

export default Card
